import Markdown from "components/markdown/markdown";

export default function Headline({
  subtitle,
  headline,
}: {
  subtitle: string;
  headline: string;
}) {
  return (
    <div className="mb-[15px] md:mb-[70px] lg:mb-10 [&_strong]:font-recklessBold [&_strong]:text-cerise">
      {headline && (
        <Markdown
          text={headline}
          className="mb-[1.25rem] font-recklessBold text-[32px] leading-[130%] md:max-w-[513px] lg:max-w-[833px] lg:text-[52px]"
        />
      )}

      <p className="mb-[70px] text-sm leading-[130%] text-mono-70">
        {subtitle}
      </p>
    </div>
  );
}
